export default __webpack_public_path__ + "static/media/Leaders_IMG-Leader-06A.3d8439ab.png";